export function LogoIcon({ mainClassName, fillClassName }) {
    return (
            <svg className={mainClassName} width="166" height="36" viewBox="0 0 166 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="139.192" width="6.18633" height="6.18633" fill="#FF8585" />
                <rect x="149.503" width="6.18633" height="6.18633" fill="#FFB84F" />
                <rect x="159.813" width="6.18633" height="6.18633" fill="#7AE448" />
                <path className={fillClassName} d="M0 34.4668V6.1864H23.3025V34.4668H18.4903V10.6248H4.81227V34.4668H0Z" fill="#F9F6EE" />
                <path className={fillClassName} d="M37.6248 35.0559C35.4683 35.0559 33.5847 34.5781 31.9739 33.6223C30.3632 32.6665 29.1119 31.3507 28.22 29.6748C27.3414 27.9859 26.9021 26.0481 26.9021 23.8616C26.9021 21.6359 27.3547 19.685 28.2599 18.0092C29.1651 16.3333 30.4231 15.024 32.0338 14.0813C33.6446 13.1387 35.5082 12.6673 37.6248 12.6673C39.7947 12.6673 41.685 13.1452 43.2957 14.101C44.9065 15.0567 46.1578 16.3791 47.0497 18.0681C47.9416 19.744 48.3875 21.6751 48.3875 23.8616C48.3875 26.0612 47.9349 28.0055 47.0297 29.6945C46.1378 31.3703 44.8865 32.6862 43.2758 33.6419C41.665 34.5846 39.7814 35.0559 37.6248 35.0559ZM37.6248 30.6175C39.5418 30.6175 40.9661 29.989 41.898 28.7321C42.8298 27.4752 43.2957 25.8517 43.2957 23.8616C43.2957 21.8061 42.8232 20.1695 41.878 18.9518C40.9329 17.7211 39.5151 17.1058 37.6248 17.1058C36.3336 17.1058 35.2686 17.3938 34.43 17.9699C33.6046 18.5329 32.9923 19.325 32.5929 20.3462C32.1936 21.3544 31.9939 22.5262 31.9939 23.8616C31.9939 25.9172 32.4665 27.5603 33.4116 28.7911C34.3701 30.0087 35.7745 30.6175 37.6248 30.6175Z" fill="#F9F6EE" />
                <path className={fillClassName} d="M49.9915 34.4668V30.4997C50.7769 30.6437 51.3826 30.6306 51.8086 30.4604C52.2346 30.2771 52.5541 29.9367 52.7671 29.4391C52.9801 28.9416 53.1664 28.2804 53.3262 27.4556C53.5392 26.2903 53.7255 24.9483 53.8853 23.4296C54.0583 21.9108 54.2048 20.2873 54.3246 18.5591C54.4577 16.8308 54.5775 15.0633 54.684 13.2565H70.5585V34.4668H65.7662V17.6949H58.9172C58.8506 18.546 58.7708 19.5017 58.6776 20.5623C58.5844 21.6097 58.4845 22.6702 58.3781 23.7438C58.2716 24.8174 58.1517 25.8386 58.0186 26.8075C57.8988 27.7633 57.7724 28.5816 57.6392 29.2624C57.3331 30.7943 56.8938 32.0053 56.3214 32.8956C55.7623 33.7859 54.9768 34.3555 53.9651 34.6042C52.9534 34.8661 51.6289 34.8203 49.9915 34.4668Z" fill="#F9F6EE" />
                <path className={fillClassName} d="M75.3495 34.4668L75.3296 13.2565H80.1418V20.3266H84.0156C84.6146 20.3266 85.2869 20.3397 86.0324 20.3659C86.7911 20.392 87.4234 20.451 87.9293 20.5426C89.1407 20.8045 90.1724 21.2234 91.0243 21.7995C91.8896 22.3756 92.5485 23.1284 93.0012 24.058C93.4538 24.9876 93.6801 26.107 93.6801 27.4163C93.6801 29.2886 93.1875 30.7877 92.2024 31.9137C91.2307 33.0266 89.8595 33.7859 88.0891 34.1918C87.5566 34.3097 86.9043 34.3882 86.1322 34.4275C85.3734 34.4537 84.6878 34.4668 84.0755 34.4668H75.3495ZM80.1418 30.755H84.4948C84.7877 30.755 85.1138 30.7419 85.4733 30.7157C85.8327 30.6895 86.1788 30.6306 86.5116 30.5389C87.1106 30.3818 87.6364 30.0283 88.0891 29.4784C88.555 28.9154 88.7879 28.2281 88.7879 27.4163C88.7879 26.5653 88.555 25.8648 88.0891 25.3149C87.6231 24.765 87.0507 24.405 86.3718 24.2348C86.0656 24.1562 85.7461 24.1038 85.4133 24.0777C85.0805 24.0515 84.7744 24.0384 84.4948 24.0384H80.1418V30.755Z" fill="#F9F6EE" />
                <path className={fillClassName} d="M104.936 35.0559C102.886 35.0559 101.016 34.6304 99.3254 33.7794C97.6347 32.9284 96.3036 31.7631 95.3318 30.2836L99.1257 27.7895C99.8978 28.6929 100.756 29.3933 101.702 29.8909C102.647 30.3753 103.698 30.6175 104.856 30.6175C106.068 30.6175 107.02 30.3556 107.712 29.8319C108.404 29.3082 108.75 28.6078 108.75 27.7305C108.75 26.9581 108.517 26.4147 108.051 26.1005C107.585 25.7732 106.973 25.5768 106.214 25.5113C105.456 25.4459 104.643 25.4131 103.778 25.4131H102.181V21.662H103.758C104.97 21.662 105.981 21.5246 106.793 21.2496C107.619 20.9747 108.031 20.3659 108.031 19.4232C108.031 18.5722 107.712 17.9699 107.073 17.6164C106.434 17.2498 105.688 17.0665 104.837 17.0665C103.798 17.0665 102.773 17.2825 101.761 17.7146C100.75 18.1466 99.8445 18.6704 99.0458 19.2857L96.3302 16.0649C97.5283 15.0175 98.8661 14.1926 100.344 13.5904C101.821 12.975 103.399 12.6673 105.076 12.6673C106.461 12.6673 107.752 12.903 108.95 13.3743C110.161 13.8457 111.133 14.5527 111.865 15.4954C112.611 16.438 112.983 17.6033 112.983 18.9911C112.983 19.9862 112.764 20.9223 112.324 21.7995C111.898 22.6767 111.213 23.5081 110.268 24.2937L110.208 22.7618C110.94 23.063 111.559 23.4819 112.065 24.0187C112.584 24.5555 112.977 25.184 113.243 25.9041C113.523 26.6242 113.662 27.3901 113.662 28.2019C113.662 29.6814 113.263 30.9317 112.464 31.953C111.666 32.9742 110.601 33.7467 109.269 34.2704C107.951 34.7941 106.507 35.0559 104.936 35.0559Z" fill="#F9F6EE" />
                <path className={fillClassName} d="M123.287 35.0559C121.73 35.0559 120.412 34.7679 119.334 34.1918C118.255 33.6026 117.437 32.8236 116.877 31.8548C116.332 30.8859 116.059 29.8188 116.059 28.6536C116.059 27.6323 116.232 26.7159 116.578 25.9041C116.924 25.0793 117.457 24.3723 118.175 23.7831C118.894 23.1808 119.826 22.6898 120.971 22.3101C121.836 22.0352 122.848 21.7864 124.006 21.5639C125.177 21.3413 126.442 21.1383 127.8 20.955C129.171 20.7586 130.602 20.5492 132.093 20.3266L130.376 21.2889C130.389 19.8225 130.056 18.7424 129.377 18.0484C128.698 17.3545 127.554 17.0076 125.943 17.0076C124.971 17.0076 124.033 17.2301 123.127 17.6753C122.222 18.1205 121.59 18.8864 121.23 19.9731L116.838 18.618C117.37 16.8243 118.382 15.3841 119.873 14.2974C121.377 13.2107 123.4 12.6673 125.943 12.6673C127.86 12.6673 129.544 12.975 130.995 13.5904C132.459 14.2057 133.544 15.2139 134.25 16.6148C134.636 17.3611 134.869 18.127 134.948 18.9126C135.028 19.685 135.068 20.5295 135.068 21.446V34.4668H130.855V29.8712L131.554 30.6175C130.582 32.1494 129.444 33.2753 128.139 33.9954C126.848 34.7024 125.231 35.0559 123.287 35.0559ZM124.246 31.2852C125.337 31.2852 126.269 31.0954 127.041 30.7157C127.813 30.336 128.426 29.8712 128.878 29.3213C129.344 28.7714 129.657 28.2543 129.817 27.7698C130.07 27.1676 130.209 26.4802 130.236 25.7077C130.276 24.9221 130.296 24.2871 130.296 23.8027L131.774 24.2348C130.323 24.4574 129.078 24.6537 128.04 24.824C127.001 24.9942 126.109 25.1578 125.364 25.3149C124.618 25.4589 123.959 25.6226 123.387 25.8059C122.828 26.0023 122.355 26.2314 121.969 26.4933C121.583 26.7551 121.284 27.0563 121.071 27.3967C120.871 27.7371 120.771 28.1364 120.771 28.5947C120.771 29.1184 120.904 29.5832 121.171 29.989C121.437 30.3818 121.823 30.6961 122.329 30.9317C122.848 31.1674 123.487 31.2852 124.246 31.2852Z" fill="#F9F6EE" />
            </svg>


            );
}


            export function HeaderMenuArrowIcon({mainClassName, strokeClassName}) {
    return (
            <svg
                width={12}
                height={12}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={mainClassName}
                viewBox="0 0 12 12"
            >
                <path
                    d="M2 8l4-4 4 4"
                    stroke="#fff"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={strokeClassName}
                />
            </svg>
            );
}

            export function HomeIcon({
                mainClassName,
                fillClassName,
}) {
    return (
            <svg
                width={20}
                height={20}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={mainClassName}
                viewBox="0 0 20 20"
            >
                <path
                    d="M11.931 16.532v-4.859a.572.572 0 00-.155-.419.553.553 0 00-.412-.157H8.636a.578.578 0 00-.42.157.572.572 0 00-.155.42v4.858h3.87zm-8.543-.254v-5.705L9.55 5.324c.3-.26.602-.26.907 0l6.162 5.249v5.705c0 .539-.157.96-.472 1.265-.314.305-.742.457-1.282.457H5.143c-.546 0-.976-.152-1.29-.457-.31-.304-.465-.726-.465-1.265zM1 9.547c0-.23.096-.427.287-.591l7.681-6.552c.32-.27.666-.404 1.04-.404.373 0 .717.135 1.031.404l7.673 6.552c.192.16.288.364.288.613a.632.632 0 01-.221.51.777.777 0 01-.53.187.681.681 0 01-.325-.083 1.907 1.907 0 01-.288-.187L10.324 3.76a.481.481 0 00-.317-.134.481.481 0 00-.317.134L2.371 9.996c-.093.07-.192.133-.295.187a.64.64 0 01-.317.083c-.236 0-.422-.07-.56-.21A.73.73 0 011 9.547zm13.555-3.631V4.08c0-.164.05-.297.148-.396a.534.534 0 01.398-.158h.995a.52.52 0 01.545.554v3.617l-2.086-1.782z"
                    fill="#E4E6EA"
                    className={fillClassName}
                />
            </svg>
            );
}

            export function AccountIcon({mainClassName, strokeClassName}) {
    return (
            <svg
                width={22}
                height={22}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={mainClassName}
                viewBox="0 0 22 22"
            >
                <path
                    d="M11 12.833a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z"
                    stroke="#505A72"
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={strokeClassName}
                />
                <path
                    d="M11 19.708a8.708 8.708 0 100-17.416 8.708 8.708 0 000 17.416z"
                    stroke="#505A72"
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={strokeClassName}
                />
                <path
                    d="M16.348 17.863a3.198 3.198 0 00-3.056-2.28H8.709a3.198 3.198 0 00-3.056 2.28"
                    stroke="#505A72"
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={strokeClassName}
                />
            </svg>
            );
}


            export function SelectedTickIcon({
                mainClassName,
                strokeClassName,
}) {
    return (
            <svg
                width={14}
                height={14}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={mainClassName}
                viewBox="0 0 14 14"
            >
                <path
                    d="M2 6.348l3.499 3.514a.2.2 0 00.279.004L12 4"
                    stroke="#505A72"
                    strokeWidth={2}
                    strokeLinecap="round"
                    className={strokeClassName}
                />
            </svg>
            );
}

            export function LogoutIcon({
                mainClassName,
                strokeClassName,
}) {
    return (
            <svg
                width={22}
                height={22}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={mainClassName}
                viewBox="0 0 22 22"
            >
                <path
                    d="M10.083 17.776V6.878c0-.633-.325-1.22-.861-1.555L5.555 3.031C4.334 2.27 2.75 3.146 2.75 4.586v10.897c0 .633.325 1.22.862 1.555l3.666 2.292c1.221.763 2.805-.115 2.805-1.554zM13.75 10.083h5.5M17.416 11.917l1.834-1.834-1.834-1.833M10.084 17.417h3.666c1.013 0 1.834-.82 1.834-1.834v-.916"
                    stroke="#505A72"
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={strokeClassName}
                />
                <path
                    d="M15.584 5.5v-.917c0-1.013-.82-1.833-1.834-1.833H4.584"
                    stroke="#505A72"
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={strokeClassName}
                />
            </svg>
            );
}
